import { render, staticRenderFns } from "./photo-section.vue?vue&type=template&id=f8e202b4&scoped=true"
import script from "./photo-section.vue?vue&type=script&lang=js"
export * from "./photo-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e202b4",
  null
  
)

export default component.exports